'use client'

import { MODAL_TYPE, Modal, type ModalAPI } from 'fukku/Modal'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useEffect, useRef } from 'react'
import { useUserDetailsContext } from 'user-data/hooks/useUserDetailsContext'

import { testIds } from '../../../constants/dataTestIds'
import { NOTIFICATION_KEY } from '../../../constants/notifications'
import { useGetNotifications } from '../../../hooks/useGetNotifications'
import { useUpdateNotifications } from '../../../hooks/useUpdateNotifications'
import {
	sendWelcomeMessageClickMLYEvent,
	sendWelcomeMessageImpressionMLYEvent,
} from '../../../utils/analytics'
import { WelcomeMessageFooter } from '../footer/WelcomeMessageFooter'

export const WelcomeMessageModal = ({
	children,
}: {
	readonly children: React.ReactNode
}) => {
	const modalRef = useRef<ModalAPI>(null)
	const { t } = useLabels()
	const { notificationsResponse } = useGetNotifications()
	const { updateNotifications } = useUpdateNotifications()

	const { userDetails } = useUserDetailsContext()
	const tier = userDetails?.loyalty?.likes?.tier?.tier

	useEffect(() => {
		const welcomeNotification = notificationsResponse?.notifications.find(
			({ type }) => type === NOTIFICATION_KEY
		)

		if (!welcomeNotification) {
			return
		}

		const showNotification = async () => {
			modalRef.current?.show()
			sendWelcomeMessageImpressionMLYEvent(tier)
			await updateNotifications(welcomeNotification.id)
		}

		showNotification()
	}, [notificationsResponse, updateNotifications])

	const handleFooterClick = () => {
		sendWelcomeMessageClickMLYEvent(tier)
		modalRef.current?.close()
	}

	return (
		<Modal
			name='spaceMangoLikesYou.welcomeMessage'
			title={t('club.welcome.clubMLY.title')}
			type={MODAL_TYPE.SHEET}
			ref={modalRef}
			footer={<WelcomeMessageFooter onClick={handleFooterClick} />}
			data-testid={testIds.welcomeMessageModal}
		>
			{children}
		</Modal>
	)
}
